export default __webpack_public_path__ + "static/media/single_web-sm@2x.6ae6f67c.webp";